<template>
	<!-- Section => Agile Slide Show	-->
	<div id="app">
		<agile :initial-slide="0" autoplay>
		<a href='./contact-us'>
			<img class="slide" src='../../assets/slideshow_main/slide-general-test.png'>
		</a>
		<a href='https://www.facebook.com/City-infrastructure-lab-104633281226873/' target='_blank'>
			<img class="slide" src='../../assets/slideshow_main/slide-facebook-page.png'>
		</a>
		<a href='./contact-us'>
			<img class="slide" src='../../assets/slideshow_main/project01.jpg'>
		</a>
		
		<template slot="prevButton">
			<font-awesome-icon :icon="['fa', 'angle-left']" />
		</template>
			
		<template slot="nextButton">
			<font-awesome-icon :icon="['fa', 'angle-right']" />
		</template>
		</agile>

	</div>
	<!-- END Section => Agile Slide Show	-->

	
</template>

<script>
import { VueAgile } from 'vue-agile'
  export default {
    components: {
        agile: VueAgile 
	},
    data() {
      return {
        myOptions: {
            navButtons: false,
            
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        dots: false
                    }
                },
                
                {
                    breakpoint: 900,
                    settings: {
                        navButtons: true,
                        dots: true,
                        infinite: false
                    }
                }
            ]
        },
      };
    },
  };
</script>

<style lang="sass">
// Global
// VueAgile styles
.agile
	&__nav-button
		background: transparent
		border: none
		color: #fff
		cursor: pointer
		font-size: 24px
		height: 100%
		position: absolute
		top: 0
		transition-duration: s
		width: 80px

		&:hover
			background-color: rgba(#000, .5)
			opacity: 1

		&--prev
			left: 0

		&--next
			right: 0

	&__dots
		bottom: 5px
		left: 50%
		position: absolute
		transform: translateX(-50%)

	&__dot
		margin: 0 10px

		button 
			background-color: transparent
			border: 1px solid #fff
			border-radius: 50%
			cursor: pointer
			display: block
			height: 10px
			font-size: 0
			line-height: 0
			margin: 0
			padding: 0
			transition-duration: .3s
			width: 10px

		&--current,
		&:hover
			button
				background-color: #fff

// Slides styles	
.slide
	display: block
	height: 300px
	object-fit: fill
	width: 100%
</style>